import { render, staticRenderFns } from "./CreatePostIndex.vue?vue&type=template&id=0f6e3ffb&scoped=true"
import script from "./CreatePostIndex.vue?vue&type=script&lang=js"
export * from "./CreatePostIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e3ffb",
  null
  
)

export default component.exports